import mixpanel from 'mixpanel-browser'

export const track = (event: string, properties?: Record<string, unknown>) => {
  try {
    console.log('tracking', event, properties)
    mixpanel.track(event, properties)
  } catch (e) {
    console.error(e)
  }
}
